import { DatePipe } from '@angular/common';
import { Component, Signal, viewChild } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { Kiosk, KioskTransaction } from '../../../../types';
import { PanModalComponent } from '../../../../components/pan-modal/pan-modal.component';

type CellParams = ICellRendererParams<Kiosk> & {
  deleteCallback: (item: Kiosk) => void;
  previewCallback: (item: Kiosk) => void;
  kioskTransactions: Signal<KioskTransaction[]>;
  loadingTransactions: Signal<boolean>;
};

@Component({
  selector: 'app-pan-cell-location-edit-kiosk-actions',
  imports: [UiModule, MatTooltipModule, RouterModule, DatePipe],
  templateUrl: './cell-location-edit-kiosk-actions.component.html',
  styleUrl: './cell-location-edit-kiosk-actions.component.scss',
})
export class CellLocationEditKioskActionsComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  public modal = viewChild<PanModalComponent>('kioskDisplayCheck');
  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }

  openModal() {
    this.params.previewCallback(this.params.data);
    this.modal()?.show();
  }
}
